import type { GetChangeRequestAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetChangeRequestAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetChangeRequestAuditByIdArgs = {
  id: string;
};

export const useGetChangeRequestAuditById = createQueryHook<
  UseGetChangeRequestAuditByIdArgs,
  GetChangeRequestAuditByIdResponseRow[],
  AuditLogQueryResult<
    'change_request_audit',
    GetChangeRequestAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getChangeRequestAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ change_request_audit: data }),
  graphqlDocument: GetChangeRequestAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
